import { render } from "./BsModal.vue?vue&type=template&id=f61eac18"
import script from "./BsModal.vue?vue&type=script&lang=js"
export * from "./BsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__